import React from "react";
import { ShieldCheck, ExternalLink } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";

const POLICIES = [
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/privacy", label: "Privacy Policy" },
  { to: "/refunds", label: "Refund & Cancellation Policy" },
  { to: "/charges", label: "Charges & Fees" },
];

// Signup consent gate. User must Accept to create an account; Decline cancels.
export default function ConsentModal({ open, onAccept, onDecline }) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onDecline?.(); }}>
      <DialogContent className="max-w-md bg-white" data-testid="consent-modal">
        <DialogHeader>
          <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-2xl bg-brand-50 text-brand"><ShieldCheck className="h-6 w-6" /></div>
          <DialogTitle className="text-xl">Review &amp; accept our policies</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-ink-soft">To create your account, please review and accept the following. They explain how the service works, what you'll pay, and how we handle your data.</p>
        <ul className="my-1 space-y-2">
          {POLICIES.map((p) => (
            <li key={p.to}>
              <a href={p.to} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between rounded-xl border border-surface-300 px-4 py-3 text-sm font-medium text-ink transition-colors hover:border-brand-200 hover:bg-brand-50" data-testid={`consent-link-${p.to.replace("/", "")}`}>
                {p.label}<ExternalLink className="h-4 w-4 text-ink-muted" />
              </a>
            </li>
          ))}
        </ul>
        <p className="text-xs text-ink-muted">By tapping “Accept &amp; continue”, you confirm you are 18+ and agree to the Terms &amp; Conditions, Privacy Policy, Refund &amp; Cancellation Policy and the Charges &amp; Fees above.</p>
        <div className="mt-2 flex gap-2">
          <Button onClick={onAccept} className="flex-1 rounded-full bg-brand text-white hover:bg-brand-600" data-testid="consent-accept">Accept &amp; continue</Button>
          <Button onClick={onDecline} variant="outline" className="flex-1 rounded-full" data-testid="consent-decline">Decline</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
